import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faPinterest,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faAt, faMobileScreen, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Tooltip } from "bootstrap";

const GastronomicVenue = ({ data }) => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);
  return (
    <div className="col-lg-6">
      <div className="h-100 rounded shadow bg-white">
        <div className="text-center">
          <div
            className={`add-img w-100 rounded-top shadow`}
            style={{ backgroundImage: `url(${data.images[0].url})`, aspectRatio: "2 / 2" }}
          />
          <div className="p-5">
            <h2 className="text-center">{data.name}</h2>
            <h4 className="text-center">{data.address}</h4>
            <p>{data.description}</p>
            {data.timetable.length > 0 && (
              <>
                <h4 className="text-center">Horario</h4>
                <div className="text-center">
                  {data.timetable.map((time) => (
                    <p className="mb-1" key={`${time.day}-${time.open}`}>
                      <b>{time.day}:</b> {time.open} a {time.close}
                      <b> {time.note}</b>.
                    </p>
                  ))}
                </div>
              </>
            )}
            {(data.phone.length > 0 || data.mobilePhone.length > 0) && (
              <h4 className="text-center">Contacto</h4>
            )}
            <p className="text-center">
              {data.social.whatsapp && (
                <a
                  href={data.social.whatsapp}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Enviales un Whatsapp"
                >
                  <FontAwesomeIcon className="text-success fs-2" icon={faWhatsapp} />
                </a>
              )}
              {data.social.facebook && (
                <a
                  href={data.social.facebook}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visitar su página de facebook"
                >
                  <FontAwesomeIcon className="text-primary fs-2" icon={faFacebookF} />
                </a>
              )}
              {data.social.instagram && (
                <a
                  href={data.social.instagram}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de Instagram"
                >
                  <FontAwesomeIcon className="text-danger fs-2" icon={faInstagram} />
                </a>
              )}
              {data.social.linkedin && (
                <a
                  href={data.social.linkedin}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de LinkedIn"
                >
                  <FontAwesomeIcon className="text-primary fs-2" icon={faLinkedinIn} />
                </a>
              )}
              {data.social.twitter && (
                <a
                  href={data.social.twitter}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de X"
                >
                  <FontAwesomeIcon className="text-dark fs-2" icon={faXTwitter} />
                </a>
              )}
              {data.social.pinterest && (
                <a
                  href={data.social.pinterest}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de Pinterest"
                >
                  <FontAwesomeIcon className="text-danger fs-2" icon={faPinterest} />
                </a>
              )}
              {data.phone.length > 0 && (
                <>
                  <a
                    href={`tel:+${data.phone}`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono fijo"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#0D47A1" }} icon={faPhone} />
                  </a>{" "}
                </>
              )}
              {data.mobilePhone.length > 0 && (
                <>
                  <a
                    href={`tel:+${data.mobilePhone}`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono móvil"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                  </a>
                </>
              )}
              {data.email && (
                <>
                  <a
                    href="mailto:emailinfo@hashotelboutique.com"
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviales un email"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#FF9800" }} icon={faAt} />
                  </a>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GastronomicVenue;
